import axios, { AxiosError } from "axios"
import { Dispatch, RNBThunkAction } from "../store.config"

import { AnyAction } from "redux"
import { FiduciaryFormData } from "../../components/RegistrationPanel"
import {
  cleanSIREN,
  SirenCheckResponseType,
  SirenStatus,
  validateAPE,
} from "../../utils/siren"
import { RootState } from "../rootReducer"
import { isAxiosError, updateStatus } from "../../utils/asyncTools"
import { cleanPhone } from "../../utils/phoneValidator"
import { getUrlFailureAction } from "./invoicing.duck"
import { UnitLabel } from "../../utils/unit"
import { UnitLabelActionEnum, UnitLabelActionType } from "./unitLabel.ducks"
import { AccountingSoftware } from "../../utils/company"
import { WritingLabelData, WritingLabelRule } from "./writingLabels.ducks"
import {
  QuadratusLabelTag,
  VatTag,
  VatTagActionEnum,
  VatTagActionType,
} from "./vatTags.duck"
import { validateUrl } from "../../utils/url"
import { ToastErrorProps } from "./merchantCodes.ducks"

const enum FiduciaryActionsEnum {
  SIREN_ATTEMPT = "FIDUCIARY/SIRENAttempt",
  FIDUCIARY_SIREN_SUCCESS = "FIDUCIARY/SIRENSuccess",
  SIREN_FAILURE = "FIDUCIARY/SIRENFailure",
  REGISTRATION_ATTEMPT = "FIDUCIARY/RegistrationAttempt",
  REGISTRATION_SUCCESS = "FIDUCIARY/RegistrationSuccess",
  REGISTRATION_FAILURE = "FIDUCIARY/RegistrationFailure",
  REGISTRATION_FAILURE_TAKEN_NAME = "FIDUCIARY/REGISTRATION_FAILURE_TAKEN_NAME",
  REGISTRATION_FAILURE_WRONG_PHONE = "FIDUCIARY/REGISTRATION_FAILURE_WRONG_PHONE",
  GET_FIDUCIARY_ATTEMPT = "FIDUCIARY/getFiduciaryAttempt",
  GET_FIDUCIARY_SUCCESS = "FIDUCIARY/getFiduciarySuccess",
  GET_FIDUCIARY_FAILURE = "FIDUCIARY/getFiduciaryFailure",
  GET_BILLS_FROM_FIDUCIARY_ATTEMPT = "FIDUCIARY/getBillsFromFiduciaryAttempt",
  GET_BILLS_FROM_FIDUCIARY_SUCCESS = "FIDUCIARY/getBillsFromFiduciarySuccess",
  GET_BILLS_FROM_FIDUCIARY_FAILURE = "FIDUCIARY/getBillsFromFiduciaryFailure",
  CHECK_EXISTING_FIDUCIARY_ATTEMPT = "FIDUCIARY/checkExistingFiduciaryAttempt",
  CHECK_EXISTING_FIDUCIARY_SUCCESS = "FIDUCIARY/checkExistingFiduciarySuccess",
  CHECK_EXISTING_FIDUCIARY_FAILURE = "FIDUCIARY/checkExistingFiduciaryFailure",
  FIDUCIARY_SIREN_HIDDEN = "FIDUCIARY/SIRENHiddenFailure",
  GET_COMPANIES_ATTEMPT = "FIDUCIARY/getCompaniesAttempt",
  GET_COMPANIES_SUCCESS = "FIDUCIARY/getCompaniesSuccess",
  GET_COMPANIES_FAILURE = "FIDUCIARY/getCompaniesFailure",
  FIDUCIARY_LOGO_UPDATE_ATTEMPT = "FIDUCIARY/logoUpdateAttempt",
  FIDUCIARY_LOGO_UPDATE_SUCCESS = "FIDUCIARY/logoUpdateSuccess",
  FIDUCIARY_LOGO_UPDATE_FAILURE = "FIDUCIARY/logoUpdateFailure",
  FIDUCIARY_INFOS_UPDATE_ATTEMPT = "FIDUCIARY/infosUpdateAttempt",
  FIDUCIARY_INFOS_UPDATE_SUCCESS = "FIDUCIARY/infosUpdateSuccess",
  FIDUCIARY_INFOS_UPDATE_FAILURE = "FIDUCIARY/infosUpdateFailure",
  REGISTER_FIDUCIARY_FRIEND = "FIDUCIARY/registerFiduciaryFriend",
  GET_INQOM_SIGN_REQUEST_ATTEMPT_ACTION = "FIDUCIARY/getInqomSignRequestAttemptAction",
  GET_INQOM_SIGN_REQUEST_SUCCESS = "FIDUCIARY/getInqomSignRequestSucessAction",
  GET_INQOM_SIGN_REQUEST_FAILURE = "FIDUCIARY/getInqomSignRequestFailureAction",
  INQOM_SIGN_REQUEST_CALLBACK_ATTEMPT_ACTION = "FIDUCIARY/inqomSignRequestCallbackAttemptAction",
  INQOM_SIGN_REQUEST_CALLBACK_SUCCESS = "FIDUCIARY/inqomSignRequestCallbackSucessAction",
  INQOM_SIGN_REQUEST_CALLBACK_FAILURE = "FIDUCIARY/inqomSignRequestCallbackFailureAction",
  FULLL_SIGN_REQUEST_PARAMS_ATTEMPT_ACTION = "FIDUCIARY/inqomSignRequestCallbackAttemptAction",
  FULLL_SIGN_REQUEST_PARAMS_SUCCESS = "FIDUCIARY/inqomSignRequestCallbackSucessAction",
  FULLL_SIGN_REQUEST_PARAMS_FAILURE = "FIDUCIARY/inqomSignRequestCallbackFailureAction",
  UPDATE_ACD_SENT_DATA_ATTEMPT = "FIDUCIARY/updateAcdSentDataAttemptActionAttempt",
  UPDATE_ACD_SENT_DATA_SUCCESS = "FIDUCIARY/updateAcdSentDataAttemptActionSuccess",
  UPDATE_ACD_SENT_DATA_ERROR = "FIDUCIARY/updateAcdSentDataAttemptActionError",
  REGISTER_ACD_ATTEMPT = "FIDUCIARY/registerAcdAttemptAction",
  REGISTER_ACD_SUCCESS = "FIDUCIARY/registerAcdSuccessAction",
  REGISTER_ACD_ERROR = "FIDUCIARY/registerAcdErrorAction",
  DISCONNECT_ACD_ATTEMPT = "FIDUCIARY/disconnectAcdAttemptAction",
  DISCONNECT_ACD_SUCCESS = "FIDUCIARY/disconnectAcdSuccessAction",
  DISCONNECT_ACD_ERROR = "FIDUCIARY/disconnectAcdErrorAction",
  GET_API_CONNECT_ATTEMPT = "FIDUCIARY/getApiConnectedAttemptAction",
  GET_API_CONNECT_SUCCESS = "FIDUCIARY/getApiConnectedSuccessAction",
  GET_API_CONNECT_ERROR = "FIDUCIARY/getApiConnectedErrorAction",
  GET_API_CONNECT_RESET = "FIDUCIARY/getApiConnectedResetAction",
  DISCONNECT_API_ATTEMPT = "FIDUCIARY/disconnectApiAttemptAction",
  DISCONNECT_API_SUCCESS = "FIDUCIARY/disconnectApiSuccessAction",
  DISCONNECT_API_ERROR = "FIDUCIARY/disconnectApiErrorAction",

  GET_MORE_API_INFOS_ATTEMPT = "FIDUCIARY/getMoreApiInfosAttemptAction",
  GET_MORE_API_INFOS_SUCCESS = "FIDUCIARY/getMoreApiInfosSuccessAction",
  GET_MORE_API_INFOS_ERROR = "FIDUCIARY/getMoreApiInfosFailureAction",

  GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_ATTEMPT = "FIDUCIARY/getAccessibleCompaniesToDisplayAttemptAction",
  GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_SUCCESS = "FIDUCIARY/getAccessibleCompaniesToDisplaySuccessAction",
  GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_ERROR = "FIDUCIARY/getAccessibleCompaniesToDisplayFailureAction",
  GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_RESET = "FIDUCIARY/getAccessibleCompaniesToDisplayResetAction",
  CREATE_COMPANY_FROM_FULLL_SUCCESS = "FIDUCIARY/createCompanyFromFulllSuccessAction",
  CREATE_COMPANY_FROM_FULLL_FAILURE = "FIDUCIARY/createCompanyFromFulllFailureAction",
  FULLL_AUTO_ONBOARDING_RESULT = "FIDUCIARY/fulllAutoOnboardingResultAction",
  FULLL_AUTO_ONBOARDINGS_RESET = "FIDUCIARY/fulllAutoOnboardingsResetAction",

  UPDATE_DEFAULT_ACCOUNTING_SOFTWARE_ATTEMPT = "FIDUCIARY/UpdateDefaultAccountingSoftwareAttempt",
  UPDATE_DEFAULT_ACCOUNTING_SOFTWARE_SUCCESS = "FIDUCIARY/UpdateDefaultAccountingSoftwareSuccess",
  UPDATE_DEFAULT_ACCOUNTING_SOFTWARE_FAILURE = "FIDUCIARY/UpdateDefaultAccountingSoftwareFailure",

  RELAUNCH_API_CONNECTION_ATTEMPT = "FIDUCIARY/relaunchApiConnectionAttempt",
  RELAUNCH_API_CONNECTION_SUCCESS = "FIDUCIARY/relaunchApiConnectionSuccess",
  RELAUNCH_API_CONNECTION_FAILURE = "FIDUCIARY/relaunchApiConnectionFailure",

  GET_COMPANIES_API_CONNECTED_ATTEMPT = "FIDUCIARY/getCompaniesApiConnectedAttempt",
  GET_COMPANIES_API_CONNECTED_SUCCESS = "FIDUCIARY/getCompaniesApiConnectedSuccess",
  GET_COMPANIES_API_CONNECTED_FAILURE = "FIDUCIARY/getCompaniesApiConnectedFailure",
  GET_COMPANIES_API_CONNECTED_RESET = "FIDUCIARY/getCompaniesApiConnectedReset",

  GET_WRITING_LABELS_DATA_ATTEMPT = "FIDUCIARY/GetWritingLabelsDataAttempt",
  GET_WRITING_LABELS_DATA_SUCCESS = "FIDUCIARY/GetWritingLabelsDataSuccess",
  GET_WRITING_LABELS_DATA_FAILURE = "FIDUCIARY/GetWritingLabelsDataFailure",

  DESTROY_WRITING_LABELS_RULE_ATTEMPT = "FIDUCIARY/DestroyWritingLabelRuleAttempt",
  DESTROY_WRITING_LABELS_RULE_SUCCESS = "FIDUCIARY/DestroyWritingLabelRuleSuccess",
  DESTROY_WRITING_LABELS_RULE_FAILURE = "FIDUCIARY/DestroyWritingLabelRuleFailure",

  CREATE_WRITING_LABELS_RULE_ATTEMPT = "COMPANY/CreateWritingLabelRuleAttempt",
  CREATE_WRITING_LABELS_RULE_SUCCESS = "COMPANY/CreateWritingLabelRuleSuccess",
  CREATE_WRITING_LABELS_RULE_FAILURE = "COMPANY/CreateWritingLabelRuleFailure",
  UPDATE_IN_OUT_API_CONNECTION_ATTEMPT_ACTION = "FIDUCIARY/updateInOutApiConnectionAttempt",
  UPDATE_IN_OUT_API_CONNECTION_SUCCESS_ACTION = "FIDUCIARY/updateInOutApiConnectionSuccess",
  UPDATE_IN_OUT_API_CONNECTION_FAILURE_ACTION = "FIDUCIARY/updateInOutApiConnectionFailure",

  CEGID_API_CONNECTION_ATTEMPT = "FIDUCIARY/cegidApiConnectionAttempt",
  CEGID_API_CONNECTION_SUCCESS = "FIDUCIARY/cegidApiConnectionSuccess",
  CEGID_API_CONNECTION_FAILURE = "FIDUCIARY/cegidApiConnectionFailure",
}

export const sirenAttemptAction = () =>
  ({ type: FiduciaryActionsEnum.SIREN_ATTEMPT } as const)
export const fiduciarySirenSuccessAction = (
  fiduciary: FiduciaryObjectType,
  duplicate: boolean
) =>
  ({
    type: FiduciaryActionsEnum.FIDUCIARY_SIREN_SUCCESS,
    payload: { fiduciary, duplicate },
  } as const)

export const sirenFailureAction = () =>
  ({ type: FiduciaryActionsEnum.SIREN_FAILURE } as const)
export const registrationAttemptAction = () =>
  ({ type: FiduciaryActionsEnum.REGISTRATION_ATTEMPT } as const)
export const registrationSuccessAction = (payload: { id: number }) =>
  ({ type: FiduciaryActionsEnum.REGISTRATION_SUCCESS, payload } as const)
export const registrationFailureAction = (error: AxiosError) =>
  ({
    type: FiduciaryActionsEnum.REGISTRATION_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: error.name,
      bodyKey: error.message,
    },
  } as const)
export const registrationFailureActionTakenFiduciaryName = () =>
  ({
    type: FiduciaryActionsEnum.REGISTRATION_FAILURE_TAKEN_NAME,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary-register.error.existing-fiduciary-name-title",
      bodyKey: "fiduciary-register.error.existing-fiduciary-name-message",
    },
  } as const)
export const registrationFailureActionWrongPhoneNumber = () =>
  ({
    type: FiduciaryActionsEnum.REGISTRATION_FAILURE_WRONG_PHONE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary-register.error.phone-field.title",
      bodyKey: "fiduciary-register.error.phone-field.message",
    },
  } as const)

export const getFiduciaryAttemptAction = () =>
  ({ type: FiduciaryActionsEnum.GET_FIDUCIARY_ATTEMPT } as const)
export const getFiduciarySuccessAction = (payload: FiduciaryPayload) =>
  ({ type: FiduciaryActionsEnum.GET_FIDUCIARY_SUCCESS, payload } as const)
export const getFiduciaryFailureAction = (error: AxiosError) =>
  ({ type: FiduciaryActionsEnum.GET_FIDUCIARY_FAILURE, error } as const)
export const getBillsFromFiduciaryAttemptAction = () =>
  ({ type: FiduciaryActionsEnum.GET_BILLS_FROM_FIDUCIARY_ATTEMPT } as const)
export const getBillsFromFiduciarySuccessAction = (payload: billsResponse[]) =>
  ({
    type: FiduciaryActionsEnum.GET_BILLS_FROM_FIDUCIARY_SUCCESS,
    payload,
  } as const)
export const getBillsFromFiduciaryFailureAction = (error: AxiosError) =>
  ({
    type: FiduciaryActionsEnum.GET_BILLS_FROM_FIDUCIARY_FAILURE,
    error,
  } as const)
export const checkExistingFiduciaryAttemptAction = () =>
  ({ type: FiduciaryActionsEnum.CHECK_EXISTING_FIDUCIARY_ATTEMPT } as const)
export const checkExistingFiduciarySuccessAction = () =>
  ({ type: FiduciaryActionsEnum.CHECK_EXISTING_FIDUCIARY_SUCCESS } as const)
export const checkExistingFiduciaryFailureAction = (error: AxiosError) =>
  ({
    type: FiduciaryActionsEnum.CHECK_EXISTING_FIDUCIARY_FAILURE,
    error,
    withoutToast: true,
  } as const)
export const fiduciarySirenHiddenAction = () =>
  ({ type: FiduciaryActionsEnum.FIDUCIARY_SIREN_HIDDEN } as const)

export const fiduciaryLogoUpdateAttemptAction = () =>
  ({ type: FiduciaryActionsEnum.FIDUCIARY_LOGO_UPDATE_ATTEMPT } as const)
export const fiduciaryLogoUpdateSuccessAction = (
  payload: UpdateFiduciaryLogoResponse
) =>
  ({
    type: FiduciaryActionsEnum.FIDUCIARY_LOGO_UPDATE_SUCCESS,
    payload,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary-register.update-logo-success.title",
      bodyKey: "fiduciary-register.update-logo-success.body",
    },
  } as const)
export const fiduciaryLogoUpdateFailureAction = () =>
  ({
    type: FiduciaryActionsEnum.FIDUCIARY_LOGO_UPDATE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary-register.update-logo-failure.title",
      bodyKey: "fiduciary-register.update-logo-failure.body",
    },
  } as const)
export const fiduciaryInfosUpdateAttemptAction = () =>
  ({ type: FiduciaryActionsEnum.FIDUCIARY_INFOS_UPDATE_ATTEMPT } as const)
export const fiduciaryInfosUpdateSuccessAction = (
  payload: UpdateFiduciaryInfosResponse
) =>
  ({
    type: FiduciaryActionsEnum.FIDUCIARY_INFOS_UPDATE_SUCCESS,
    payload,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary-register.update-infos-success.title",
      bodyKey: "fiduciary-register.update-infos-success.body",
    },
  } as const)
export const fiduciaryInfosUpdateFailureAction = (error: AxiosError) =>
  ({
    type: FiduciaryActionsEnum.FIDUCIARY_INFOS_UPDATE_FAILURE,
    error,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: error.name,
      bodyKey: error.message,
    },
  } as const)
export const registerFiduciaryFriend = (payload: UPdateFiduciaryReferer) =>
  ({
    type: FiduciaryActionsEnum.REGISTER_FIDUCIARY_FRIEND,
    payload,
  } as const)

export const getInqomSignRequestAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_INQOM_SIGN_REQUEST_ATTEMPT_ACTION,
  } as const)
export const getInqomSignRequestSuccessAction = (
  payload: GetInqomSignRequestInfosResponse
) =>
  ({
    type: FiduciaryActionsEnum.GET_INQOM_SIGN_REQUEST_SUCCESS,
    payload,
  } as const)
export const getInqomSignRequestFailureAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_INQOM_SIGN_REQUEST_FAILURE,
  } as const)

export const inqomSignRequestCallbackAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.INQOM_SIGN_REQUEST_CALLBACK_ATTEMPT_ACTION,
  } as const)
export const inqomSignRequestCallbackSuccessAction = () =>
  ({
    type: FiduciaryActionsEnum.INQOM_SIGN_REQUEST_CALLBACK_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary.settings.inqom.connect.success.title",
      bodyKey: "fiduciary.settings.inqom.connect.success.body",
    },
  } as const)
export const inqomSignRequestCallbackFailureAction = () =>
  ({
    type: FiduciaryActionsEnum.INQOM_SIGN_REQUEST_CALLBACK_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary.settings.inqom.connect.failure.title",
      bodyKey: "fiduciary.settings.inqom.connect.failure.body",
    },
  } as const)

export const fulllSignRequestParamsAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.FULLL_SIGN_REQUEST_PARAMS_ATTEMPT_ACTION,
  } as const)
export const fulllSignRequestParamsSuccessAction = () =>
  ({
    type: FiduciaryActionsEnum.FULLL_SIGN_REQUEST_PARAMS_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary.settings.fulll.connect.success.title",
      bodyKey: "fiduciary.settings.fulll.connect.success.body",
    },
  } as const)
export const fulllSignRequestParamsFailureAction = () =>
  ({
    type: FiduciaryActionsEnum.FULLL_SIGN_REQUEST_PARAMS_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary.settings.fulll.connect.failure.title",
      bodyKey: "fiduciary.settings.fulll.connect.failure.body",
    },
  } as const)

export const updateAcdSentDataAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.UPDATE_ACD_SENT_DATA_ATTEMPT,
  } as const)

export const updateAcdSentDataSuccessAction = ({
  fiduciaryId,
  dueDate,
  documentReference,
  acdApidPeriodicity,
  acdApiAnalytic,
}: {
  fiduciaryId: number
  dueDate: boolean
  documentReference: boolean
  acdApidPeriodicity: boolean
  acdApiAnalytic: boolean
}) =>
  ({
    type: FiduciaryActionsEnum.UPDATE_ACD_SENT_DATA_SUCCESS,
    payload: {
      fiduciaryId,
      dueDate,
      documentReference,
      acdApidPeriodicity,
      acdApiAnalytic,
    },
  } as const)

export const updateAcdSentDataErrorAction = () =>
  ({
    type: FiduciaryActionsEnum.UPDATE_ACD_SENT_DATA_ERROR,
  } as const)

export const registerAcdAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.REGISTER_ACD_ATTEMPT,
  } as const)
export const registerAcdSuccessAction = () =>
  ({
    type: FiduciaryActionsEnum.REGISTER_ACD_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `fiduciary-settings.toaster.success.sign.in.acd.title`,
      bodyKey: `fiduciary-settings.toaster.success.sign.in.acd.body`,
    },
  } as const)
export const registerAcdErrorAction = (errorMessage?: string) =>
  ({
    type: FiduciaryActionsEnum.REGISTER_ACD_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `fiduciary-settings.toaster.error.sign.in.acd.title`,
      bodyKey: errorMessage
        ? `fiduciary-settings.toaster.error.sign.in.acd.body`
        : `fiduciary-settings.toaster.error.sign.in.acd.body.default`,
      bodyValues: errorMessage ? { errorMessage } : {},
    },
  } as const)

export const getApiConnectedAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_API_CONNECT_ATTEMPT,
  } as const)
export const getApiConnectedSuccessAction = (apiConnected: boolean) =>
  ({
    type: FiduciaryActionsEnum.GET_API_CONNECT_SUCCESS,
    payload: { apiConnected },
  } as const)
export const getApiConnectedErrorAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_API_CONNECT_ERROR,
  } as const)
export const getApiConnectedResetAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_API_CONNECT_RESET,
  } as const)

export const disconnectAcdAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.DISCONNECT_ACD_ATTEMPT,
  } as const)
export const disconnectAcdSuccessAction = () =>
  ({
    type: FiduciaryActionsEnum.DISCONNECT_ACD_SUCCESS,
  } as const)
export const disconnectAcdErrorAction = () =>
  ({
    type: FiduciaryActionsEnum.DISCONNECT_ACD_ERROR,
  } as const)

export const UpdateDefaultAccountingSoftwareAttempt = () =>
  ({
    type: FiduciaryActionsEnum.UPDATE_DEFAULT_ACCOUNTING_SOFTWARE_ATTEMPT,
  } as const)
export const UpdateDefaultAccountingSoftwareSuccess = (
  newSoftware: AccountingSoftware
) =>
  ({
    type: FiduciaryActionsEnum.UPDATE_DEFAULT_ACCOUNTING_SOFTWARE_SUCCESS,
    newSoftware,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary-settings.change-software.tooltip.success-title",
      bodyKey: "fiduciary-settings.change-software.tooltip.success-message",
    },
  } as const)
export const UpdateDefaultAccountingSoftwareFailure = () =>
  ({
    type: FiduciaryActionsEnum.UPDATE_DEFAULT_ACCOUNTING_SOFTWARE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary-settings.change-software.tooltip.error-title",
      bodyKey: "fiduciary-settings.change-software.tooltip.error-message",
    },
  } as const)

export const relaunchApiConnectionAttempt = () =>
  ({
    type: FiduciaryActionsEnum.RELAUNCH_API_CONNECTION_ATTEMPT,
  } as const)
export const relaunchApiConnectionSuccess = () =>
  ({
    type: FiduciaryActionsEnum.RELAUNCH_API_CONNECTION_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "fiduciary-settings.relaunch-api-connection.success-title",
      bodyKey: "fiduciary-settings.relaunch-api-connection.success-message",
    },
  } as const)
export const relaunchApiConnectionFailure = () =>
  ({
    type: FiduciaryActionsEnum.RELAUNCH_API_CONNECTION_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "fiduciary-settings.relaunch-api-connection.error-title",
      bodyKey: "fiduciary-settings.relaunch-api-connection.error-message",
    },
  } as const)

export const getCompaniesApiConnectedAttempt = () =>
  ({
    type: FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_ATTEMPT,
  } as const)
export const getCompaniesApiConnectedSuccess = (
  payload: CompanyApiConnectedInfo[]
) =>
  ({
    type: FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_SUCCESS,
    payload: payload,
  } as const)
export const getCompaniesApiConnectedFailure = () =>
  ({
    type: FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_FAILURE,
  } as const)
export const getCompaniesApiConnectedReset = () =>
  ({
    type: FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_RESET,
  } as const)

export const getWritingLabelsDataAttempt = () =>
  ({
    type: FiduciaryActionsEnum.GET_WRITING_LABELS_DATA_ATTEMPT,
  } as const)
export const getWritingLabelsDataSuccess = (payload: WritingLabelData) =>
  ({
    type: FiduciaryActionsEnum.GET_WRITING_LABELS_DATA_SUCCESS,
    payload,
  } as const)
export const getWritingLabelsDataFailure = () =>
  ({
    type: FiduciaryActionsEnum.GET_WRITING_LABELS_DATA_FAILURE,
  } as const)

export const DestroyWritingLabelRuleAttempt = () =>
  ({
    type: FiduciaryActionsEnum.DESTROY_WRITING_LABELS_RULE_ATTEMPT,
  } as const)
export const DestroyWritingLabelRuleSuccess = () =>
  ({
    type: FiduciaryActionsEnum.DESTROY_WRITING_LABELS_RULE_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `office-company.writing-labels.destroy-tooltip-success.title`,
      bodyKey: `office-company.writing-labels.destroy-tooltip-success.message`,
    },
  } as const)
export const DestroyWritingLabelRuleFailure = () =>
  ({
    type: FiduciaryActionsEnum.DESTROY_WRITING_LABELS_RULE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `office-company.writing-labels.destroy-tooltip-error.title`,
      bodyKey: `office-company.writing-labels.destroy-tooltip-error.message`,
    },
  } as const)

export const CreateWritingLabelRuleAttempt = () =>
  ({
    type: FiduciaryActionsEnum.CREATE_WRITING_LABELS_RULE_ATTEMPT,
  } as const)
export const CreateWritingLabelRuleSuccess = () =>
  ({
    type: FiduciaryActionsEnum.CREATE_WRITING_LABELS_RULE_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `office-company.writing-labels.create-tooltip-success.title`,
      bodyKey: `office-company.writing-labels.create-tooltip-success.message`,
    },
  } as const)
export const CreateWritingLabelRuleFailure = () =>
  ({
    type: FiduciaryActionsEnum.CREATE_WRITING_LABELS_RULE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `office-company.writing-labels.create-tooltip-error.title`,
      bodyKey: `office-company.writing-labels.create-tooltip-error.message`,
    },
  } as const)
export const disconnectApiAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.DISCONNECT_API_ATTEMPT,
  } as const)
export const disconnectApiSuccessAction = () =>
  ({
    type: FiduciaryActionsEnum.DISCONNECT_API_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `office-fiduciary.disconnect_api.success.title`,
      bodyKey: `office-fiduciary.disconnect_api.success.message`,
    },
  } as const)
export const disconnectApiErrorAction = () =>
  ({
    type: FiduciaryActionsEnum.DISCONNECT_API_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `office-fiduciary.disconnect_api.error.title`,
      bodyKey: `office-fiduciary.disconnect_api.error.message`,
    },
  } as const)
export const getMoreApiInfosAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_MORE_API_INFOS_ATTEMPT,
  } as const)
export const getMoreApiInfosSuccessAction = (
  payload: GetMoreApiInformationResponse
) =>
  ({
    type: FiduciaryActionsEnum.GET_MORE_API_INFOS_SUCCESS,
    payload,
  } as const)
export const getMoreApiInfosErrorAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_MORE_API_INFOS_ERROR,
  } as const)
export const getAccessibleCompaniesToDisplayAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_ATTEMPT,
  } as const)
export const getAccessibleCompaniesToDisplaySuccessAction = (
  payload: CompanyAccessible[]
) =>
  ({
    type: FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_SUCCESS,
    payload,
  } as const)
export const getAccessibleCompaniesToDisplayErrorAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_ERROR,
  } as const)
export const getAccessibleCompaniesToDisplayResetAction = () =>
  ({
    type: FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_RESET,
  } as const)
export const createCompanyFromFulllSuccessAction = (
  externalId: string,
  companyId: number
) =>
  ({
    type: FiduciaryActionsEnum.CREATE_COMPANY_FROM_FULLL_SUCCESS,
    payload: { externalId, companyId },
  } as const)
export const fulllAutoOnboardingResultAction = (
  companyId: number,
  success: boolean,
  name: string,
  reason: string
) =>
  ({
    type: FiduciaryActionsEnum.FULLL_AUTO_ONBOARDING_RESULT,
    payload: { companyId, success },
    withToast: true,
    toasterType: success ? "success" : "error",
    message: {
      titleKey: `fiduciary-settings.api-accessible-companies.onboarding.${
        success ? "success" : "error"
      }.title`,
      bodyKey: `fiduciary-settings.api-accessible-companies.onboarding.${
        success ? "success" : "error"
      }.body`,
      bodyValues: { name, reason },
    },
  } as const)
export const fulllAutoOnboardingsResetAction = () =>
  ({ type: FiduciaryActionsEnum.FULLL_AUTO_ONBOARDINGS_RESET } as const)
export const createCompanyFromFulllFailureAction = (error: string) =>
  ({
    type: FiduciaryActionsEnum.CREATE_COMPANY_FROM_FULLL_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey:
        "fiduciary-settings.api-accessible-companies.create.error.title",
      bodyKey: "fiduciary-settings.api-accessible-companies.create.error.body",
      bodyValues: { error },
    },
  } as const)

export const cegidApiConnectionAttemptAction = () =>
  ({
    type: FiduciaryActionsEnum.CEGID_API_CONNECTION_ATTEMPT,
  } as const)
export const cegidApiConnectionSuccessAction = () =>
  ({
    type: FiduciaryActionsEnum.CEGID_API_CONNECTION_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `fiduciary-settings.cegid-api.connection.success.title`,
      bodyKey: `fiduciary-settings.cegid-api.connection.success.body`,
    },
  } as const)
export const cegidApiConnectionFailureAction = (error: ToastErrorProps) =>
  ({
    type: FiduciaryActionsEnum.CEGID_API_CONNECTION_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: error.titleKey,
      bodyKey: error.bodyKey,
      bodyValues: error.bodyValues,
    },
  } as const)

type FiduciaryActionsType = ReturnType<
  | typeof sirenAttemptAction
  | typeof fiduciarySirenSuccessAction
  | typeof sirenFailureAction
  | typeof registrationAttemptAction
  | typeof registrationSuccessAction
  | typeof registrationFailureAction
  | typeof registrationFailureActionTakenFiduciaryName
  | typeof getFiduciaryAttemptAction
  | typeof getFiduciarySuccessAction
  | typeof getFiduciaryFailureAction
  | typeof getBillsFromFiduciaryAttemptAction
  | typeof getBillsFromFiduciarySuccessAction
  | typeof getBillsFromFiduciaryFailureAction
  | typeof checkExistingFiduciaryAttemptAction
  | typeof checkExistingFiduciarySuccessAction
  | typeof checkExistingFiduciaryFailureAction
  | typeof fiduciarySirenHiddenAction
  | typeof fiduciaryLogoUpdateAttemptAction
  | typeof fiduciaryLogoUpdateSuccessAction
  | typeof fiduciaryLogoUpdateFailureAction
  | typeof fiduciaryInfosUpdateAttemptAction
  | typeof fiduciaryInfosUpdateSuccessAction
  | typeof fiduciaryInfosUpdateFailureAction
  | typeof registerFiduciaryFriend
  | typeof registrationFailureActionWrongPhoneNumber
  | typeof getInqomSignRequestAttemptAction
  | typeof getInqomSignRequestSuccessAction
  | typeof getInqomSignRequestFailureAction
  | typeof inqomSignRequestCallbackAttemptAction
  | typeof inqomSignRequestCallbackSuccessAction
  | typeof inqomSignRequestCallbackFailureAction
  | typeof fulllSignRequestParamsAttemptAction
  | typeof fulllSignRequestParamsSuccessAction
  | typeof fulllSignRequestParamsFailureAction
  | typeof updateAcdSentDataAttemptAction
  | typeof updateAcdSentDataSuccessAction
  | typeof updateAcdSentDataErrorAction
  | typeof registerAcdAttemptAction
  | typeof registerAcdSuccessAction
  | typeof registerAcdErrorAction
  | typeof getApiConnectedAttemptAction
  | typeof getApiConnectedSuccessAction
  | typeof getApiConnectedErrorAction
  | typeof getApiConnectedResetAction
  | typeof disconnectAcdAttemptAction
  | typeof disconnectAcdSuccessAction
  | typeof disconnectAcdErrorAction
  | typeof UpdateDefaultAccountingSoftwareAttempt
  | typeof UpdateDefaultAccountingSoftwareSuccess
  | typeof UpdateDefaultAccountingSoftwareFailure
  | typeof relaunchApiConnectionAttempt
  | typeof relaunchApiConnectionSuccess
  | typeof relaunchApiConnectionFailure
  | typeof getCompaniesApiConnectedAttempt
  | typeof getCompaniesApiConnectedSuccess
  | typeof getCompaniesApiConnectedFailure
  | typeof getCompaniesApiConnectedReset
  | typeof getWritingLabelsDataAttempt
  | typeof getWritingLabelsDataSuccess
  | typeof getWritingLabelsDataFailure
  | typeof DestroyWritingLabelRuleAttempt
  | typeof DestroyWritingLabelRuleSuccess
  | typeof DestroyWritingLabelRuleFailure
  | typeof CreateWritingLabelRuleAttempt
  | typeof CreateWritingLabelRuleSuccess
  | typeof CreateWritingLabelRuleFailure
  | typeof disconnectApiAttemptAction
  | typeof disconnectApiSuccessAction
  | typeof disconnectApiErrorAction
  | typeof getMoreApiInfosAttemptAction
  | typeof getMoreApiInfosSuccessAction
  | typeof getMoreApiInfosErrorAction
  | typeof getAccessibleCompaniesToDisplayAttemptAction
  | typeof getAccessibleCompaniesToDisplaySuccessAction
  | typeof getAccessibleCompaniesToDisplayErrorAction
  | typeof getAccessibleCompaniesToDisplayResetAction
  | typeof createCompanyFromFulllSuccessAction
  | typeof createCompanyFromFulllFailureAction
  | typeof fulllAutoOnboardingResultAction
  | typeof fulllAutoOnboardingsResetAction
  | typeof cegidApiConnectionAttemptAction
  | typeof cegidApiConnectionSuccessAction
  | typeof cegidApiConnectionFailureAction
>

interface CegidApiConnection {
  id: string
  api_key_id: string
}

interface FiduciaryObjectType {
  code_ape: null | string
  siren: null | string
  sirenState: SirenStatus
  isBadApe: boolean
  name: string
  companies: Array<CompanyObjectType>
  address: string
  city: string
  postalCode: string
  phone: string
  accounting_software: AccountingSoftware | null
  created_at: string
  companies_creation_locked_at: boolean
  ape_details: string
  country: string
  country_code: string
  full_legal_form: string
  legal_form: string | null
  max_work_force: number
  min_work_force: number
  postal_code: string
  share_capital: string | null
  siege_siret: string
  vat_number: string | null
  work_force: string
  unit_labels: UnitLabel[]
  in_out_api_connection: boolean
  acd_api_periodicity: boolean
  vat_tags: {
    length_limit: number
    data: VatTag[] | QuadratusLabelTag[]
  }
  hide_bills_from_fiduciary_at: string | null
  cegid_api_connection: CegidApiConnection | null
}

export interface FiduciaryState extends FiduciaryObjectType {
  id: number
  sirenCheck: "CHECKING" | "VALIDATED" | "INVALID" | "UNCHECKED"
  referer: null | string
  logoId: number | null
  status: "UNREGISTERED" | "INVALID" | "SUCCESS"
  fiduciaryInfoUpdateStatus: updateStatus
  logoUrl: null | string
  bills: null | billsResponse[]
  inqom_sign_request?: GetInqomSignRequestInfosResponse
  acd_api_due_date: boolean
  acd_api_document_reference: boolean
  acd_api_periodicity: boolean
  acd_api_analytic: boolean
  coala_api_activated: boolean
  api_connected: boolean
  apiConnectedStatus: "CHECKING" | "CHECKED" | "ERROR" | "IDLE"
  active_pricing: Pricing | null
  override_pricing: boolean
  cash_or_accrual: "cash" | "accrual" | "both"
  companiesApiConnected: CompanyApiConnectedInfo[]
  fulllTokenCreationStatus: "IDLE" | "PENDING" | "ERROR" | "SUCCESS"
  relaunchApiConnexionStatus: "IDLE" | "PENDING" | "ERROR" | "SUCCESS"
  writing_labels_data: WritingLabelData
  has_api_users: boolean
  has_in_extenso_fulll_token: boolean
  more_api_infos: GetMoreApiInformationResponse
  accessible_api_companies: CompanyAccessible[]
  get_accessible_companies_status: "IDLE" | "PENDING" | "ERROR" | "SUCCESS"
  fulll_onboardings: Record<number, FulllOnboardingStatus>
  get_companies_api_connected_status: "IDLE" | "PENDING" | "ERROR" | "SUCCESS"
  cegidApiConnectionStatus: "IDLE" | "PENDING" | "ERROR" | "SUCCESS"
}

export interface billsResponse {
  id: number
  date: Date
  amount: number
  status: string
}

export interface StandardLedgerType {
  id: number
  confirmed: boolean
  original_file_name: string
  file_name: string
}

interface FiscalYearType {
  id: number
  begin_exercise: string
  end_exercise: string
}
export interface CompanyObjectType {
  id: number
  company_name: string
  identification_number: string
  email_capture: string
  user_company_name: null | string
  hidden_from_team: boolean
  accounting_software_reference: null | string
  standard_ledgers: Array<StandardLedgerType>
  fiscal_years: Array<FiscalYearType>
}
export const fiduciaryInitialState: FiduciaryState = {
  id: 0,
  sirenCheck: "UNCHECKED",
  referer: null,
  code_ape: null,
  siren: null,
  sirenState: null,
  isBadApe: false,
  logoId: null,
  name: "",
  address: "",
  city: "",
  postalCode: "",
  phone: "",
  status: "UNREGISTERED",
  companies: [],
  accounting_software: null,
  fiduciaryInfoUpdateStatus: "IDLE",
  logoUrl: null,
  bills: null,
  created_at: "",
  companies_creation_locked_at: false,
  acd_api_due_date: true,
  acd_api_document_reference: true,
  acd_api_periodicity: true,
  acd_api_analytic: false,
  coala_api_activated: true,
  api_connected: false,
  apiConnectedStatus: "IDLE",
  active_pricing: null,
  override_pricing: false,
  cash_or_accrual: "both",
  ape_details: "",
  country: "",
  country_code: "",
  full_legal_form: "",
  legal_form: "",
  max_work_force: 0,
  min_work_force: 0,
  postal_code: "",
  share_capital: null,
  siege_siret: "",
  vat_number: null,
  work_force: "",
  unit_labels: [],
  vat_tags: { length_limit: 0, data: [] },
  companiesApiConnected: [],
  fulllTokenCreationStatus: "IDLE",
  relaunchApiConnexionStatus: "IDLE",
  writing_labels_data: {
    fields: {},
  },
  in_out_api_connection: false,
  has_api_users: false,
  has_in_extenso_fulll_token: false,
  more_api_infos: {},
  accessible_api_companies: [],
  get_accessible_companies_status: "IDLE",
  fulll_onboardings: {},
  get_companies_api_connected_status: "IDLE",
  hide_bills_from_fiduciary_at: null,
  cegidApiConnectionStatus: "IDLE",
  cegid_api_connection: null,
}

export function fiduciaryReducer(
  state = fiduciaryInitialState,
  action: FiduciaryActionsType | UnitLabelActionType | VatTagActionType
): FiduciaryState {
  switch (action.type) {
    case FiduciaryActionsEnum.SIREN_ATTEMPT:
      return { ...state, sirenCheck: "CHECKING" }
    case FiduciaryActionsEnum.FIDUCIARY_SIREN_SUCCESS: {
      let sirenState: SirenStatus = "ok"
      let isBadApe = false
      if (action.payload.duplicate) {
        sirenState = "taken fiduciary"
      }
      if (
        action.payload.fiduciary.code_ape &&
        !validateAPE(action.payload.fiduciary.code_ape)
      ) {
        isBadApe = true
      }
      return {
        ...state,
        ...action.payload.fiduciary,
        sirenCheck: "VALIDATED",
        sirenState,
        isBadApe,
      }
    }
    case FiduciaryActionsEnum.SIREN_FAILURE:
      return { ...state, sirenCheck: "INVALID", sirenState: "not found" }
    case FiduciaryActionsEnum.GET_FIDUCIARY_ATTEMPT:
      return { ...state }
    case FiduciaryActionsEnum.GET_FIDUCIARY_SUCCESS:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        address: action.payload.address,
        city: action.payload.city,
        postalCode: action.payload.postalCode,
        phone: action.payload.phone,
        accounting_software: action.payload.accounting_software,
        logoId: action.payload.logoId,
        status: "SUCCESS",
        logoUrl: action.payload.logoUrl,
        created_at: action.payload.created_at,
        companies_creation_locked_at:
          action.payload.companies_creation_locked_at,
        acd_api_due_date: action.payload.acd_api_due_date,
        acd_api_document_reference: action.payload.acd_api_document_reference,
        acd_api_periodicity: action.payload.acd_api_periodicity,
        acd_api_analytic: action.payload.acd_api_analytic,
        coala_api_activated: action.payload.coala_api_activated,
        active_pricing: action.payload.active_pricing,
        override_pricing: action.payload.override_pricing,
        cash_or_accrual: action.payload.cash_or_accrual,
        in_out_api_connection: action.payload.in_out_api_connection,
        has_api_users: action.payload.has_api_users,
        has_in_extenso_fulll_token: action.payload.has_in_extenso_fulll_token,
        hide_bills_from_fiduciary_at:
          action.payload.hide_bills_from_fiduciary_at,
        cegid_api_connection: action.payload.cegid_api_connection,
      }
    case FiduciaryActionsEnum.GET_FIDUCIARY_FAILURE:
      return { ...state }

    case FiduciaryActionsEnum.FULLL_SIGN_REQUEST_PARAMS_ATTEMPT_ACTION:
      return { ...state, fulllTokenCreationStatus: "PENDING" }

    case FiduciaryActionsEnum.FULLL_SIGN_REQUEST_PARAMS_SUCCESS:
      return { ...state, fulllTokenCreationStatus: "SUCCESS" }

    case FiduciaryActionsEnum.FULLL_SIGN_REQUEST_PARAMS_FAILURE:
      return { ...state, fulllTokenCreationStatus: "ERROR" }

    case FiduciaryActionsEnum.GET_BILLS_FROM_FIDUCIARY_ATTEMPT:
      return { ...state }
    case FiduciaryActionsEnum.GET_BILLS_FROM_FIDUCIARY_SUCCESS:
      return {
        ...state,
        bills: action.payload,
      }
    case FiduciaryActionsEnum.GET_BILLS_FROM_FIDUCIARY_FAILURE:
      return { ...state }
    case FiduciaryActionsEnum.RELAUNCH_API_CONNECTION_ATTEMPT:
      return { ...state, relaunchApiConnexionStatus: "PENDING" }
    case FiduciaryActionsEnum.RELAUNCH_API_CONNECTION_SUCCESS:
      return { ...state, relaunchApiConnexionStatus: "SUCCESS" }
    case FiduciaryActionsEnum.RELAUNCH_API_CONNECTION_FAILURE:
      return { ...state, relaunchApiConnexionStatus: "ERROR" }

    case FiduciaryActionsEnum.CHECK_EXISTING_FIDUCIARY_ATTEMPT:
      return { ...state }
    case FiduciaryActionsEnum.CHECK_EXISTING_FIDUCIARY_SUCCESS:
      return { ...state, status: "SUCCESS" }
    case FiduciaryActionsEnum.CHECK_EXISTING_FIDUCIARY_FAILURE:
      return { ...state, status: "UNREGISTERED" }
    case FiduciaryActionsEnum.REGISTRATION_SUCCESS:
      return { ...state, id: action.payload.id, status: "SUCCESS" }
    case FiduciaryActionsEnum.REGISTRATION_FAILURE:
      return { ...state }
    case FiduciaryActionsEnum.REGISTRATION_FAILURE_TAKEN_NAME:
      return { ...state }
    case FiduciaryActionsEnum.FIDUCIARY_SIREN_HIDDEN:
      return { ...state, sirenCheck: "INVALID", sirenState: "hidden" }
    case FiduciaryActionsEnum.FIDUCIARY_INFOS_UPDATE_ATTEMPT:
      return {
        ...state,
        fiduciaryInfoUpdateStatus: "ATTEMPT",
      }
    case FiduciaryActionsEnum.FIDUCIARY_INFOS_UPDATE_SUCCESS:
      return {
        ...state,
        name: action.payload.fiduciary.fiduciary_name,
        address: action.payload.fiduciary.street_infos,
        city: action.payload.fiduciary.city,
        postalCode: action.payload.fiduciary.postal_code,
        phone: action.payload.fiduciary.phone,
        fiduciaryInfoUpdateStatus: "SUCCESS",
        acd_api_due_date: action.payload.fiduciary.acdApiDueDate,
        acd_api_document_reference:
          action.payload.fiduciary.acdApiDocumentReference,
        in_out_api_connection: action.payload.fiduciary.inOutApiConnected,
        acd_api_periodicity: action.payload.fiduciary.acdApiPeriodicity,
        acd_api_analytic: action.payload.fiduciary.acdApiAnalytic,
        coala_api_activated: action.payload.fiduciary.coalaApiActivated,
      }
    case FiduciaryActionsEnum.FIDUCIARY_INFOS_UPDATE_FAILURE:
      return {
        ...state,
        fiduciaryInfoUpdateStatus: "ERROR",
      }
    case FiduciaryActionsEnum.FIDUCIARY_LOGO_UPDATE_SUCCESS:
      return {
        ...state,
        logoId: action.payload.obj_id,
      }
    case FiduciaryActionsEnum.REGISTER_FIDUCIARY_FRIEND:
      return {
        ...state,
        referer: action.payload.referer,
      }
    case FiduciaryActionsEnum.GET_INQOM_SIGN_REQUEST_SUCCESS:
      return {
        ...state,
        inqom_sign_request: action.payload,
      }
    case FiduciaryActionsEnum.UPDATE_ACD_SENT_DATA_SUCCESS: {
      return {
        ...state,
        acd_api_due_date: action.payload.dueDate,
        acd_api_document_reference: action.payload.documentReference,
        acd_api_periodicity: action.payload.acdApidPeriodicity,
        acd_api_analytic: action.payload.acdApiAnalytic,
      }
    }
    case FiduciaryActionsEnum.GET_API_CONNECT_SUCCESS: {
      return {
        ...state,
        api_connected: action.payload.apiConnected,
        apiConnectedStatus: "CHECKED",
      }
    }
    case FiduciaryActionsEnum.GET_API_CONNECT_ERROR: {
      return {
        ...state,
        apiConnectedStatus: "ERROR",
      }
    }
    case FiduciaryActionsEnum.GET_API_CONNECT_ATTEMPT: {
      return {
        ...state,
        apiConnectedStatus: "CHECKING",
      }
    }
    case FiduciaryActionsEnum.GET_API_CONNECT_RESET: {
      return {
        ...state,
        apiConnectedStatus: "IDLE",
      }
    }
    case FiduciaryActionsEnum.UPDATE_DEFAULT_ACCOUNTING_SOFTWARE_SUCCESS: {
      return {
        ...state,
        accounting_software: action.newSoftware,
      }
    }
    case UnitLabelActionEnum.GET_FIDUCIARY_UNIT_LABELS_SUCCESS: {
      return {
        ...state,
        unit_labels: action.unitLabels,
      }
    }
    case FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_ATTEMPT: {
      return {
        ...state,
        get_companies_api_connected_status: "PENDING",
      }
    }
    case FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_SUCCESS: {
      return {
        ...state,
        companiesApiConnected: action.payload,
        get_companies_api_connected_status: "SUCCESS",
      }
    }
    case FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_FAILURE: {
      return {
        ...state,
        get_companies_api_connected_status: "ERROR",
      }
    }
    case FiduciaryActionsEnum.GET_COMPANIES_API_CONNECTED_RESET: {
      return {
        ...state,
        companiesApiConnected: [],
        get_companies_api_connected_status: "IDLE",
      }
    }
    case FiduciaryActionsEnum.GET_WRITING_LABELS_DATA_SUCCESS: {
      return {
        ...state,
        writing_labels_data: action.payload,
      }
    }
    case VatTagActionEnum.GET_QUADRATUS_FIDUCIARY_LABEL_TAGS_SUCCESS:
    case VatTagActionEnum.GET_FIDUCIARY_VAT_TAGS_SUCCESS: {
      return {
        ...state,
        vat_tags: action.vatTags,
      }
    }
    case FiduciaryActionsEnum.GET_MORE_API_INFOS_SUCCESS: {
      return {
        ...state,
        more_api_infos: {
          ...action.payload,
        },
      }
    }
    case FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_SUCCESS: {
      return {
        ...state,
        accessible_api_companies: action.payload,
        get_accessible_companies_status: "SUCCESS",
      }
    }
    case FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_ERROR: {
      return {
        ...state,
        accessible_api_companies: [],
        get_accessible_companies_status: "ERROR",
      }
    }
    case FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_ATTEMPT: {
      return {
        ...state,
        get_accessible_companies_status: "PENDING",
      }
    }
    case FiduciaryActionsEnum.GET_ACCESSIBLE_COMPANIES_TO_DISPLAY_RESET: {
      return {
        ...state,
        accessible_api_companies: [],
        get_accessible_companies_status: "IDLE",
      }
    }
    case FiduciaryActionsEnum.CREATE_COMPANY_FROM_FULLL_SUCCESS: {
      return {
        ...state,
        accessible_api_companies: state.accessible_api_companies.map((row) =>
          String(row.external_id) === String(action.payload.externalId)
            ? { ...row, id: action.payload.companyId }
            : row
        ),
        fulll_onboardings: {
          ...state.fulll_onboardings,
          [action.payload.companyId]: "PENDING",
        },
      }
    }
    case FiduciaryActionsEnum.FULLL_AUTO_ONBOARDING_RESULT: {
      return {
        ...state,
        fulll_onboardings: {
          ...state.fulll_onboardings,
          [action.payload.companyId]: action.payload.success
            ? "SUCCESS"
            : "ERROR",
        },
      }
    }
    case FiduciaryActionsEnum.FULLL_AUTO_ONBOARDINGS_RESET: {
      return { ...state, fulll_onboardings: {} }
    }

    case FiduciaryActionsEnum.CEGID_API_CONNECTION_ATTEMPT: {
      return { ...state, cegidApiConnectionStatus: "PENDING" }
    }
    case FiduciaryActionsEnum.CEGID_API_CONNECTION_SUCCESS: {
      return { ...state, cegidApiConnectionStatus: "SUCCESS" }
    }

    case FiduciaryActionsEnum.CEGID_API_CONNECTION_FAILURE: {
      return { ...state, cegidApiConnectionStatus: "ERROR" }
    }

    default:
      return { ...state }
  }
}

export const attemptFiduciaryRegistrationThunk =
  (fiduciaryFormData: FiduciaryFormData) =>
  (dispatch: Dispatch<FiduciaryActionsType>, getState: () => RootState) => {
    dispatch(registrationAttemptAction())
    const fiduciaryRegistrationURI = "/fiduciaries"
    const fiduciary = getState().fiduciary

    const requestPayload = {
      fiduciary_name: fiduciaryFormData.fiduciaryName,
      street_infos: fiduciaryFormData.address,
      city: fiduciaryFormData.city,
      postal_code: fiduciaryFormData.postalCode,
      phone: cleanPhone(fiduciaryFormData.phone),
      origin: fiduciaryFormData.localisation.value,
      accounting_software: fiduciaryFormData.accounting_software.value,
      how_did_you_hear: fiduciaryFormData.discovery.value,
      identification_number: fiduciary.siren,
      code_ape: fiduciary.code_ape,
      fiduciary_friend: fiduciary.referer,
    }

    axios
      .post<{ id: number }>(`${fiduciaryRegistrationURI}`, requestPayload)
      .then((response) => {
        return dispatch(registrationSuccessAction(response.data))
      })
      .catch((e) => {
        if ("fiduciary_name" in e.response.data.error) {
          return dispatch(registrationFailureActionTakenFiduciaryName())
        }
        if ("phone" in e.response.data.error) {
          return dispatch(registrationFailureActionWrongPhoneNumber())
        }
        return dispatch(registrationFailureAction(e))
      })
  }

export const attemptSirenValidationThunk =
  (siren: string) => (dispatch: Dispatch<FiduciaryActionsType>) => {
    dispatch(sirenAttemptAction())
    const redundancyCheckURI = "/fiduciaries/existing_fiduciary"
    const sirenValidationURI = "/companies/siren_to_name"

    let fiduciaryExistsInDB: null | boolean = null
    let fiduciary = {}

    axios
      .get<SirenCheckResponseType>(`${sirenValidationURI}`, {
        params: {
          siren: cleanSIREN(siren),
          scope: "fiduciary",
        },
      })
      .then((response) => {
        fiduciary = {
          code_ape: response.data.code_ape || null,
          siren: cleanSIREN(siren),
          name: response.data.name || "",
          address: response.data.address || "",
          city: response.data.city || "",
          postalCode: response.data.postal_code || "",
          phone: "",
          sirenState: null,
          isBadApe: false,
          companies: [],
          accounting_software: "",
          created_at: "",
          companies_creation_locked_at: false,
          ape_details: response.data.ape_details || "",
          country: response.data.country || "",
          country_code: response.data.country_code || "FR",
          full_legal_form: response.data.full_legal_form || "",
          legal_form: response.data.legal_form || "",
          max_work_force: response.data.max_work_force || 0,
          min_work_force: response.data.min_work_force || 0,
          share_capital: response.data.share_capital || null,
          siege_siret: response.data.siege_siret || "",
          vat_number: response.data.vat_number || null,
          work_force: response.data.work_force || "",
        }
      })
      .then(() =>
        axios.get<boolean>(`${redundancyCheckURI}`, {
          params: {
            identification_number: cleanSIREN(siren),
          },
        })
      )
      .then((response) => {
        fiduciaryExistsInDB = response.data
        return dispatch(
          fiduciarySirenSuccessAction(
            fiduciary as FiduciaryObjectType,
            fiduciaryExistsInDB
          )
        )
      })
      .catch((e) => {
        if (
          typeof e.response.data === "string" &&
          e.response.data.includes("Unité légale non diffusable")
        ) {
          return dispatch(fiduciarySirenHiddenAction())
        }
        return dispatch(sirenFailureAction())
      })
  }

export const getFiduciaryThunk = () => (dispatch: Dispatch<AnyAction>) => {
  dispatch(getFiduciaryAttemptAction())
  return axios
    .get<FiduciaryResponse>(`/users/get_fiduciary`)
    .then(({ data }) => {
      dispatch(
        getFiduciarySuccessAction({
          id: data.fiduciary.id,
          name: data.fiduciary.fiduciary_name,
          address: data.fiduciary.street_infos,
          city: data.fiduciary.city,
          postalCode: data.fiduciary.postal_code,
          phone: data.fiduciary.phone,
          accounting_software: data.fiduciary.accounting_software,
          logoId: data.logo,
          logoUrl: data.logo_url,
          created_at: data.fiduciary.created_at,
          companies_creation_locked_at: data.fiduciary
            .companies_creation_locked_at
            ? true
            : false,
          acd_api_due_date: data.fiduciary.acd_api_due_date,
          acd_api_document_reference: data.fiduciary.acd_api_document_reference,
          acd_api_periodicity: data.fiduciary.acd_api_periodicity,
          acd_api_analytic: data.fiduciary.acd_api_analytic,
          coala_api_activated: data.fiduciary.coala_api_activated,
          active_pricing: data.active_pricing,
          override_pricing: data.override_pricing,
          cash_or_accrual: data.fiduciary.cash_or_accrual,
          in_out_api_connection: data.fiduciary.in_out_api_connection,
          has_api_users: data.fiduciary.has_api_users,
          has_in_extenso_fulll_token: data.fiduciary.has_in_extenso_fulll_token,
          hide_bills_from_fiduciary_at:
            data.fiduciary.hide_bills_from_fiduciary_at,
          cegid_api_connection: data.fiduciary.cegid_api_connection,
        })
      )
    })
    .catch((e: AxiosError) => {
      dispatch(getFiduciaryFailureAction(e))
    })
}
export const checkExistingFiduciaryThunk =
  () => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getFiduciaryAttemptAction())
    return axios
      .get<FiduciaryResponse>(`/users/get_fiduciary`)
      .then(({ data }) => {
        dispatch(checkExistingFiduciarySuccessAction())
      })
      .catch((e: AxiosError) => {
        dispatch(checkExistingFiduciaryFailureAction(e))
      })
  }

interface FiduciaryPayload {
  id: number
  name: string
  address: string
  city: string
  postalCode: string
  phone: string
  logoId: number
  logoUrl: string | null
  accounting_software: AccountingSoftware
  created_at: string
  companies_creation_locked_at: boolean
  acd_api_due_date: boolean
  acd_api_document_reference: boolean
  acd_api_periodicity: boolean
  acd_api_analytic: boolean
  coala_api_activated: boolean
  active_pricing: Pricing | null
  override_pricing: boolean
  cash_or_accrual: "cash" | "accrual" | "both"
  in_out_api_connection: boolean
  has_api_users: boolean
  has_in_extenso_fulll_token: boolean
  hide_bills_from_fiduciary_at: string | null
  cegid_api_connection: CegidApiConnection | null
}

interface FiduciaryResponse {
  fiduciary: {
    id: number
    fiduciary_name: string
    street_infos: string
    city: string
    postal_code: string
    phone: string
    accounting_software: AccountingSoftware
    created_at: string
    companies_creation_locked_at: boolean
    acd_api_due_date: boolean
    acd_api_document_reference: boolean
    acd_api_periodicity: boolean
    acd_api_analytic: boolean
    coala_api_activated: boolean
    cash_or_accrual: "cash" | "accrual" | "both"
    in_out_api_connection: boolean
    has_api_users: boolean
    has_in_extenso_fulll_token: boolean
    hide_bills_from_fiduciary_at: string | null
    cegid_api_connection: CegidApiConnection | null
  }
  logo: number
  logo_url: string | null
  active_pricing: Pricing
  override_pricing: boolean
}

interface Pricing {
  cash_accounting_price_in_cents: string
  price_in_cents: string
  pricing_type: "per_company_month" | "per_document" | null
}

export interface UploadPayload {
  originalFileName: string
  originalFileSize: number
  fingerprint: string
  file: File
}

interface UpdateFiduciaryLogoResponse {
  status: "ok"
  obj_id: number
  file_name: string
}

interface UPdateFiduciaryReferer {
  referer: string
}

export interface SignRequestResponse {
  put_url: string
}

interface UpdateFiduciaryInfosPayload {
  name: string
  address: string
  city: string
  postalCode: string
  phone: string
  acdApiDueDate: boolean | null
  acdApiDocumentReference: boolean | null
  inOutApiConnected: boolean | null
  acdApiPeriodicity: boolean | null
  acdApiAnalytic: boolean | null
  coalaApiActivated: boolean | null
}

interface UpdateFiduciaryInfosResponse {
  fiduciary: {
    fiduciary_name: string
    street_infos: string
    city: string
    postal_code: string
    phone: string
    acdApiDueDate: boolean
    acdApiDocumentReference: boolean
    inOutApiConnected: boolean
    acdApiPeriodicity: boolean
    acdApiAnalytic: boolean
    coalaApiActivated: boolean
  }
}

export interface GetInqomSignRequestInfosResponse {
  connected: boolean
  params: {
    response_type: string
    scope: string
    client_id: string
    state: string
    redirect_uri: string
    request_url: string
  }
}

interface GetBillDownloadUrlResponse {
  url: string
  status: "success" | "error"
}

export const updateFiduciaryLogoThunk =
  ({ originalFileName, originalFileSize, fingerprint, file }: UploadPayload) =>
  (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
    dispatch(fiduciaryLogoUpdateAttemptAction())
    return axios
      .post<UpdateFiduciaryLogoResponse>(`/fiduciary_logos`, {
        fiduciary_id: getState().fiduciary.id,
        fingerprint: fingerprint,
        original_file_name: originalFileName,
        original_file_size: originalFileSize,
      })
      .then(({ data }) => {
        signRequest(data.obj_id).then((res) => {
          const headers = { "Cache-Control": "max-age=31536000" }
          axios
            .put(res.data.put_url, file, {
              withCredentials: false,
              headers: headers,
            })
            .then(() => {
              dispatch(
                fiduciaryLogoUpdateSuccessAction({
                  obj_id: data.obj_id,
                  file_name: originalFileName,
                  status: "ok",
                })
              )
            })
        })
      })
      .catch(() => {
        dispatch(fiduciaryLogoUpdateFailureAction())
      })
  }

function signRequest(id: number) {
  return axios.put<SignRequestResponse>(`/fiduciary_logos/sign_request`, {
    id,
  })
}

export const getBillsFromFiduciaryThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getBillsFromFiduciaryAttemptAction())
    return axios
      .get<billsResponse[]>(`/fiduciaries/get_bills_per_fiduciary`, {
        params: { fiduciary_id: fiduciaryId },
      })
      .then((response) => {
        if (response.data.length === 0) {
          dispatch(getBillsFromFiduciarySuccessAction([]))
        } else {
          dispatch(getBillsFromFiduciarySuccessAction(response.data))
        }
      })
      .catch((e: AxiosError) => {
        dispatch(getBillsFromFiduciaryFailureAction(e))
      })
  }

export const updateFiduciaryInfosThunk =
  ({
    name,
    address,
    city,
    postalCode,
    phone,
    acdApiDueDate,
    acdApiDocumentReference,
    inOutApiConnected,
    acdApiPeriodicity,
    acdApiAnalytic,
    coalaApiActivated,
  }: UpdateFiduciaryInfosPayload) =>
  (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
    dispatch(fiduciaryInfosUpdateAttemptAction())
    const fiduciary = getState().fiduciary
    return axios
      .put<UpdateFiduciaryInfosResponse>(`/fiduciaries/${fiduciary.id}`, {
        fiduciary: {
          id: fiduciary.id,
          fiduciary_name: name,
          street_infos: address,
          city,
          postal_code: postalCode,
          phone,
          acd_api_due_date: acdApiDueDate || false,
          acd_api_document_reference: acdApiDocumentReference || false,
          in_out_api_connection: inOutApiConnected || false,
          acd_api_periodicity: acdApiPeriodicity || false,
          acd_api_analytic: acdApiAnalytic || false,
          coala_api_activated: coalaApiActivated || false,
        },
      })
      .then(() => {
        dispatch(
          fiduciaryInfosUpdateSuccessAction({
            fiduciary: {
              fiduciary_name: name,
              street_infos: address,
              city: city,
              postal_code: postalCode,
              phone,
              acdApiDueDate: acdApiDueDate || false,
              acdApiDocumentReference: acdApiDocumentReference || false,
              inOutApiConnected: inOutApiConnected || false,
              acdApiPeriodicity: acdApiPeriodicity || false,
              acdApiAnalytic: acdApiAnalytic || false,
              coalaApiActivated: coalaApiActivated || false,
            },
          })
        )
      })
      .catch((e: AxiosError) => {
        dispatch(fiduciaryInfosUpdateFailureAction(e))
      })
  }

export const getUrlForBillThunk =
  (fullDocumentId: number) => (dispatch: Dispatch<AnyAction>) => {
    axios
      .get<GetBillDownloadUrlResponse>("/fiduciaries/get_bill_download_url", {
        params: { id: fullDocumentId },
      })
      .then(({ data }) => {
        const validUrl = validateUrl(data.url)
        if (data.status === "success" && validUrl)
          window.open(validUrl, "download")
        else dispatch(getUrlFailureAction())
      })
      .catch(() => dispatch(getUrlFailureAction()))
  }

export const getInqomSignRequestThunk =
  (fiduciary_id: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getInqomSignRequestAttemptAction())
    return axios
      .get<GetInqomSignRequestInfosResponse>(
        "fiduciaries/inqom_sign_request_params",
        {
          params: { fiduciary_id: fiduciary_id },
        }
      )
      .then((response) => {
        dispatch(getInqomSignRequestSuccessAction(response.data))
      })
      .catch((e: AxiosError) => {
        dispatch(getInqomSignRequestFailureAction())
      })
  }

export const inqomSignRequestCallback =
  (params: unknown, fiduciary_id: number) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(inqomSignRequestCallbackAttemptAction())
    return axios
      .post("fiduciaries/inqom_sign_request_callback", params)
      .then((response) => {
        dispatch(getInqomSignRequestThunk(fiduciary_id))
        dispatch(inqomSignRequestCallbackSuccessAction())
      })
      .catch((e) => {
        dispatch(inqomSignRequestCallbackFailureAction())
      })
  }

export type FulllVersion = "fulll" | "in_extenso"

export const fulllSignRequestParamsThunk =
  ({
    params,
    fiduciary_id,
    fulll_version,
  }: {
    params: unknown
    fiduciary_id: number
    fulll_version: FulllVersion
  }) =>
  // code=U4z2mgYgesjWuV6FXUOqu505bbt2po4y
  // &company=5626
  // &company_filenumber=GRP46-001
  // &company_corporate_name=CHAINTRUST+1

  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(fulllSignRequestParamsAttemptAction())
    return axios
      .post("fiduciaries/fulll_sign_request_params", {
        ...(params as {}),
        fiduciary_id,
        fulll_version,
      })
      .then((response) => {
        dispatch(fulllSignRequestParamsSuccessAction())
      })
      .catch((e) => {
        dispatch(fulllSignRequestParamsFailureAction())
      })
  }

export const updateAcdSentDataFiducaryThunk =
  ({
    fiduciaryId,
    dueDate,
    documentReference,
    acdApiPeriodicity,
    acdApiAnalytic,
  }: {
    fiduciaryId: number
    dueDate: boolean | null
    documentReference: boolean | null
    acdApiPeriodicity: boolean | null
    acdApiAnalytic: boolean | null
  }) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(updateAcdSentDataAttemptAction())
    return axios
      .post(`/fiduciaries/update_acd_sent_data_for_fiduciary`, {
        fiduciary_id: fiduciaryId,
        acd_api_due_date: dueDate || false,
        acd_api_document_reference: documentReference || false,
        acd_api_periodicity: acdApiPeriodicity || false,
        acd_api_analytic: acdApiAnalytic || false,
      })
      .then(() => {
        dispatch(
          updateAcdSentDataSuccessAction({
            fiduciaryId: fiduciaryId,
            dueDate: dueDate || false,
            documentReference: documentReference || false,
            acdApidPeriodicity: acdApiPeriodicity || false,
            acdApiAnalytic: acdApiAnalytic || false,
          })
        )
      })
      .catch(() => {
        dispatch(updateAcdSentDataErrorAction())
      })
  }

export const getApiConnected =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(getApiConnectedResetAction())
    dispatch(getApiConnectedAttemptAction())
    return axios
      .get<{ api_connected: boolean }>("fiduciaries/api_connected_request", {
        params: { fiduciary_id: fiduciaryId },
      })
      .then((response) => {
        dispatch(getApiConnectedSuccessAction(response.data.api_connected))
      })
      .catch((e: AxiosError) => {
        dispatch(getApiConnectedErrorAction())
      })
  }

export const registerACDApi =
  ({
    fiduciaryId,
    identifier,
    password,
    cnx,
    apiUrl,
  }: {
    fiduciaryId: number
    identifier: string
    password: string
    cnx: string
    apiUrl: string
  }) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(registerAcdAttemptAction())
    return axios
      .post("fiduciaries/acd_sign_request", {
        fiduciary_id: fiduciaryId,
        identifier: identifier,
        password: password,
        cnx: cnx,
        api_url: apiUrl,
      })
      .then(() => {
        dispatch(registerAcdSuccessAction())
        dispatch(getApiConnected(fiduciaryId))
      })
      .catch((e) => {
        let errorMessage: string | undefined
        if (isAxiosError(e) && e.response?.data) {
          const message = (e.response.data as { message?: string })?.message
          if (message) {
            try {
              const errorData = JSON.parse(message)
              errorMessage = errorData?.error_message
            } catch {
              errorMessage = message
            }
          }
        }
        dispatch(registerAcdErrorAction(errorMessage))
      })
  }

export const UpdateDefaultAccountingSoftwareThunk =
  (fiduciaryId: number, newSoftware: AccountingSoftware) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(UpdateDefaultAccountingSoftwareAttempt())
    return axios
      .post("fiduciaries/update_default_software", {
        fiduciary_id: fiduciaryId,
        accounting_software: newSoftware,
      })
      .then(() => {
        dispatch(UpdateDefaultAccountingSoftwareSuccess(newSoftware))
        dispatch(getApiConnected(fiduciaryId))
      })
      .catch((e) => {
        dispatch(UpdateDefaultAccountingSoftwareFailure())
      })
  }

export const relaunchApiConnectionThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(relaunchApiConnectionAttempt())
    return axios
      .post("fiduciaries/relaunch_api_connection", {
        fiduciary_id: fiduciaryId,
      })
      .then(() => {
        dispatch(relaunchApiConnectionSuccess())
        dispatch(getCompaniesApiConnectedThunk(fiduciaryId))
      })
      .catch((e) => {
        dispatch(relaunchApiConnectionFailure())
      })
  }

export interface CompanyApiConnectedInfo {
  id: number
  company_name: string
  user_company_name: string
  identification_number: string
  accounting_software: string
}

interface companyApiConnectedReponse {
  api_companies_connected: CompanyApiConnectedInfo[]
}

export const getCompaniesApiConnectedThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getCompaniesApiConnectedAttempt())
    return axios
      .get<companyApiConnectedReponse>(
        "fiduciaries/get_api_companies_connected",
        {
          params: {
            fiduciary_id: fiduciaryId,
          },
        }
      )
      .then((response) =>
        dispatch(
          getCompaniesApiConnectedSuccess(response.data.api_companies_connected)
        )
      )
      .catch((e) => {
        dispatch(getCompaniesApiConnectedFailure())
      })
  }

export const GetWritingLabelDataThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction>) => {
    dispatch(getWritingLabelsDataAttempt())
    return axios
      .get<WritingLabelData>(`fiduciaries/${fiduciaryId}/writing_labels_data`)
      .then((response) => dispatch(getWritingLabelsDataSuccess(response.data)))
      .catch(() => dispatch(getWritingLabelsDataFailure()))
  }

export const DestroyWritingLabelRuleThunk =
  (fiduciaryId: number, writingLabelRuleId: number) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(DestroyWritingLabelRuleAttempt())
    return axios
      .put(`fiduciaries/${fiduciaryId}/destroy_writing_label_rule`, {
        writing_label_rule_id: writingLabelRuleId,
      })
      .then(() => {
        dispatch(DestroyWritingLabelRuleSuccess())
        dispatch(GetWritingLabelDataThunk(fiduciaryId))
      })
      .catch(() => dispatch(DestroyWritingLabelRuleFailure()))
  }
export const CreateWritingLabelRuleThunk =
  (fiduciaryId: number, new_rule: WritingLabelRule) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(CreateWritingLabelRuleAttempt())
    return axios
      .put(`fiduciaries/${fiduciaryId}/create_or_edit_writing_label_rule`, {
        new_rule: new_rule,
      })
      .then(() => {
        dispatch(CreateWritingLabelRuleSuccess())
        dispatch(GetWritingLabelDataThunk(fiduciaryId))
      })
      .catch(() => dispatch(CreateWritingLabelRuleFailure()))
  }

export const disconnectApiThunk =
  (fiduciaryId: number, software: AccountingSoftware) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(disconnectApiAttemptAction())
    return axios
      .post(`fiduciaries/${fiduciaryId}/disconnect_api`)
      .then((response) => {
        dispatch(disconnectApiSuccessAction())
        dispatch(getApiConnected(fiduciaryId))
        if (software === "inqom")
          dispatch(getInqomSignRequestThunk(fiduciaryId))
      })
      .catch(() => dispatch(disconnectApiErrorAction()))
  }

interface CreatedAtApiInfo {
  created_at: string
}

interface AcdApiInfo extends CreatedAtApiInfo {
  api_identifier: string
  api_url: string
  cnx: string
  user_email?: string | null
}

interface FulllApiInfo extends CreatedAtApiInfo {
  fulll_version_type: string
}

interface CoalaApiInfo extends CreatedAtApiInfo {
  external_id: string
}

export interface CompanyAccessible {
  name: string
  siren_siret: string
  external_id: string
  id?: number
  accounting_software?: string
}

export type FulllOnboardingStatus = "PENDING" | "SUCCESS" | "ERROR"

interface ApiSection<T extends CreatedAtApiInfo> {
  api_infos: T
}

export interface GetMoreApiInformationResponse {
  acd?: ApiSection<AcdApiInfo>
  fulll?: ApiSection<FulllApiInfo>
  coala?: ApiSection<CoalaApiInfo>
  inqom?: ApiSection<CreatedAtApiInfo>
}

export const getMoreApiInfosThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(getMoreApiInfosAttemptAction())
    return axios
      .get<GetMoreApiInformationResponse>(
        `fiduciaries/${fiduciaryId}/get_more_api_infos`
      )
      .then((response) => {
        dispatch(getMoreApiInfosSuccessAction(response.data))
      })
      .catch(() => dispatch(getMoreApiInfosErrorAction()))
  }

export const getAccessibleCompaniesToDisplayThunk =
  (fiduciaryId: number) => (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(getAccessibleCompaniesToDisplayAttemptAction())
    return axios
      .get<CompanyAccessible[]>(
        `fiduciaries/${fiduciaryId}/get_api_accessible_companies_to_display`
      )
      .then((response) => {
        dispatch(getAccessibleCompaniesToDisplaySuccessAction(response.data))
      })
      .catch(() => dispatch(getAccessibleCompaniesToDisplayErrorAction()))
  }

export const associateCompanyToCegidThunk =
  (connectionId: number, companyId: number, fiduciaryId: number) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) =>
    axios
      .put(`cegid_api_connections/${connectionId}/associate_company`, {
        company_id: companyId,
      })
      .then(() => {
        dispatch(getCompaniesApiConnectedThunk(fiduciaryId))
        dispatch(getAccessibleCompaniesToDisplayThunk(fiduciaryId))
      })

export const createCompanyFromFulllThunk =
  (fiduciaryId: number, fulllCompanyId: string) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) =>
    axios
      .post<{ id: number; display_name: string }>(
        "companies/create_from_fulll",
        { fulll_company_id: fulllCompanyId }
      )
      .then((response) => {
        dispatch(
          createCompanyFromFulllSuccessAction(fulllCompanyId, response.data.id)
        )
        dispatch(getCompaniesApiConnectedThunk(fiduciaryId))
      })
      .catch((error: AxiosError<{ error?: string }>) => {
        dispatch(
          createCompanyFromFulllFailureAction(
            error.response?.data?.error ?? error.message
          )
        )
      })

const getCegidApiConnectionErrorMessages = (
  error: AxiosError | Error,
  defaultKey = "default"
) => {
  let key = defaultKey
  let bodyValues = {}

  if (
    isAxiosError(error) &&
    error.response !== undefined &&
    error.response.data
  ) {
    const errorMsg = JSON.stringify(error.response.data)

    if (errorMsg.includes("ApiKey and/or the Secret is invalid")) {
      key = "invalid-credentials"
    }
  }

  return {
    titleKey: `fiduciary-settings.cegid-api.error.${key}.title`,
    bodyKey: `fiduciary-settings.cegid-api.error.${key}.body`,
    bodyValues,
  }
}
export const cegidApiConnectionThunk =
  (fiduciaryId: number, api_key_id: string, api_key_secret: string) =>
  (dispatch: Dispatch<FiduciaryActionsType | RNBThunkAction>) => {
    dispatch(cegidApiConnectionAttemptAction())
    return axios
      .post(`fiduciaries/${fiduciaryId}/cegid_api_connection`, {
        api_key_id,
        api_key_secret,
      })
      .then(() => {
        dispatch(getApiConnected(fiduciaryId))
        dispatch(cegidApiConnectionSuccessAction())
      })
      .catch((error: AxiosError) => {
        dispatch(
          cegidApiConnectionFailureAction(
            getCegidApiConnectionErrorMessages(error)
          )
        )
      })
  }
